angular.module('impactx.vcatalog').controller('VCatalogExportSettingsCtrl', VCatalogExportSettingsCtrl);

VCatalogExportSettingsCtrl.$inject = ['$scope', 'dataGen', 'DownloadService',
    '$securityManager', '$config', 'TranslationService', 'themeFactory', '$mdDialog'];

function VCatalogExportSettingsCtrl($scope, dataGen, DownloadService, $securityManager, $config,
                                     TranslationService, themeFactory, $mdDialog) {
    var ctrl = this;

    $scope.theme = themeFactory.getTheme();

    dataGen.getData($scope, {}, ctrl.optionsEntrypoint).then(function() {
        $scope.trns.required = TranslationService.get('required');
        $scope.trns.abort = TranslationService.get('abort');

    });

    function collectParams() {
        var params = [];
        if (ctrl.vcatId) {
            params.push({paramName: "vcatId", paramValue: ctrl.vcatId});
        }
        if ($scope.data.name) {
            params.push({paramName: "name", paramValue: $scope.data.name.value});
        }
        if ($scope.data.exportImages) {
            params.push({paramName: "exportImages", paramValue: $scope.data.exportImages.value});
        }
        if ($scope.data.exportVCatalogs) {
            params.push({paramName: "exportVCatalogs", paramValue: $scope.data.exportVCatalogs.value});
        }
        if ($scope.data.exportCatalogs) {
            params.push({paramName: "exportCatalogs", paramValue: $scope.data.exportCatalogs.value});
        }
        return params;
    }

    this.disableExport = function () {
        if ($scope.data && !$scope.dialogData.$invalid) {
            if ($scope.data.exportCatalogs || $scope.data.exportVCatalogs) {
                return !impactX.isDefined($scope, 'data.exportCatalogs.value') &&
                    !impactX.isDefined($scope, 'data.exportVCatalogs.value');
            }
            return false;
        }
        return true;
    }



    this.export = function () {
        DownloadService.openParamDownloadPost(ctrl.exportEntrypoint, collectParams());
        if (ctrl.vcatId) {
            $mdDialog.hide();
        }
    };

    this.cancel = function ()
    {
        $mdDialog.cancel();
    };
}